import { MessageBar, MessageBarType, PrimaryButton, Spinner, SpinnerSize } from '@fluentui/react';
import React, { useEffect, useState } from 'react'
import Api from '../../../services/Api';
import PeoplePicker from "../../formFields/PeoplePicker";
import { useSelector } from 'react-redux';
import { PermissionRole } from '../../../GlobalConst/globalEnums';


const TempAdmins = ({environmentId}) => {

    const currentUser = useSelector(state => state.user.currentUser);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [users, setUsers] = useState([currentUser]);
    const [isSaving, setIsSaving] = useState(false);
    const [environment, setEnvironment] = useState({})


    useEffect(() => {
        getEnvironment(environmentId);
    }, []);

    const getEnvironment = (environmentId) => {
        Api.get(`/EnvironmentsPanel?id=${environmentId}`)
        .then(res => res.data)
        .then(env => {
            setEnvironment(env);
        });
    }

    const addAdmins = () => {
        setSuccess(false);
        setError(false);

        if (users.length > 0) {
            setIsSaving(true);

            Api.post('AdminUpdatePowerAppEnvironmentRequest', {
                id: environmentId,
                tempAdminsUsers: users
            })
            .then(res => res.data)
            .then(post => {
                setSuccess(true);
                setIsSaving(false);
            }).catch((error) => {
                setError(true);
                setIsSaving(false);
            })
        }
    }

    const activeTempAdmins = environment.tempAdmins

    return (
        <div style={divContainer}>
            <div>Added users will be automatically removed from Environment after 72 hours.</div>
            <div style={divContainer}>
                <PeoplePicker
                    defaultUsers={users}
                    onSelectedUsers={setUsers}
                    disabled={currentUser.role !== PermissionRole.administrator}
                />
            </div>
            <div style={divContainer}>
            {   
                isSaving
                ? <Spinner size={SpinnerSize.medium} style={{ float: 'left' }} />
                : <PrimaryButton onClick={addAdmins}>Add</PrimaryButton>
            }
            </div>
            <div style={divContainer}>
                { success && <MessageBar messageBarType={MessageBarType.success}>Request sent successfully. Administrators will be added in a few minutes.</MessageBar> }
                { error && <MessageBar messageBarType={MessageBarType.error}>Error occured during sending request.</MessageBar> }
            </div>
            <div>
                <div style={{fontWeight: 'bold', paddingBottom: '3px'}}>Temporary Administrators:</div>
                <div>
                    {
                        activeTempAdmins
                        ?
                            (activeTempAdmins.length 
                            ? activeTempAdmins.map(x => <div key={x.id} title={x.email}>{x.displayName}</div>)
                            : 'None')
                        : <div style={{float: 'left', padding: '10px 0px 25px'}}><Spinner size={SpinnerSize.small} /></div>
                    }
                </div>
            </div>
        </div>
    );
}

const divContainer = {
    padding: '10px 0'
}


export default TempAdmins




// WEBPACK FOOTER //
// ./src/components/Administration/PowerPlatform/TempEnvironmentAdmins.js